import styled from 'styled-components'

export const Container = styled.article`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
`
